var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnapshot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m276.53 446.91 4.28 39.77a229.93706 229.93706 0 0 0 42.04-8.46l-11.52-38.31a191.42161 191.42161 0 0 1 -34.8 7z",
    fill: "#2d80b3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m192.60986 479.23a230.11769 230.11769 0 0 0 42.18014 7.81l3.6499-39.83a192.31768 192.31768 0 0 1 -34.8999-6.46z",
    fill: "#379ec3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m410.29 370.29-34.29-34.29v96h96l-33.16992-33.17a232.06529 232.06529 0 0 0 -79.43994-350.57l-17.82007 35.82a192.06183 192.06183 0 0 1 68.72 286.21z",
    fill: "#e44042"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m24 256a231.987 231.987 0 0 0 128.60986 207.74l17.82007-35.82a192.06183 192.06183 0 0 1 -68.72-286.21l34.29007 34.29v-96h-96l33.16992 33.17a230.98265 230.98265 0 0 0 -49.16992 142.83z",
    fill: "#8acce7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m189.1499 33.78 11.52 38.31a191.42671 191.42671 0 0 1 34.80005-7l-4.28-39.77a229.93194 229.93194 0 0 0 -42.04005 8.46z",
    fill: "#bf2226"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m273.56006 64.79a192.32292 192.32292 0 0 1 34.89994 6.46l10.93018-38.48a230.11769 230.11769 0 0 0 -42.18018-7.81z",
    fill: "#d1393b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m192 384h128a24 24 0 0 0 24-24v-184l-48-48h-104a24 24 0 0 0 -24 24v208a24 24 0 0 0 24 24z",
    fill: "#eedc9a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#eebe33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m296 128v48h48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 152h32v16h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208 200h80v16h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 200h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 264h32v16h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 264h80v16h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 232h64v16h-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 232h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 296h64v16h-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.798 296h31.202v16h-31.202z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.798 328h31.202v16h-31.202z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapshot);
export default __webpack_public_path__ + "static/media/snapshot.0a55101671e4398f92378dc8373dfe61.svg";
export { ForwardRef as ReactComponent };